var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container calendar-list-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "form-item-width",
              attrs: { clearable: "", placeholder: "请选择投诉来源" },
              model: {
                value: _vm.listQuery.complaintsSource,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "complaintsSource", $$v)
                },
                expression: "listQuery.complaintsSource"
              }
            },
            _vm._l(_vm.complaintOption, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.name, value: item.value }
              })
            }),
            1
          ),
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: { type: "text", clearable: "", placeholder: "请输入联系人" },
            model: {
              value: _vm.listQuery.contact,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "contact", $$v)
              },
              expression: "listQuery.contact"
            }
          }),
          _c(
            "el-select",
            {
              staticClass: "form-item-width",
              attrs: { clearable: "", placeholder: "请选择紧急情况" },
              model: {
                value: _vm.listQuery.situationType,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "situationType", $$v)
                },
                expression: "listQuery.situationType"
              }
            },
            _vm._l(_vm.situationOption, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.name, value: item.value }
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "form-item-width",
              attrs: { clearable: "", placeholder: "请选择状态" },
              model: {
                value: _vm.listQuery.status,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "status", $$v)
                },
                expression: "listQuery.status"
              }
            },
            _vm._l(_vm.statusOption, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.name, value: item.value }
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "form-item-width",
              attrs: { clearable: "", placeholder: "请选择回访状态" },
              model: {
                value: _vm.listQuery.isVisit,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "isVisit", $$v)
                },
                expression: "listQuery.isVisit"
              }
            },
            _vm._l(_vm.visitOption, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.name, value: item.value }
              })
            }),
            1
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter }
            },
            [_vm._v(_vm._s(_vm.$t("button.search")))]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "element-loading-text": "数据正在加载中...",
            border: "",
            stripe: "",
            fit: "",
            "highlight-current-row": ""
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: _vm.$t("table.id"), width: "50" }
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "投诉单号", "min-width": "150px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "link-type",
                        on: {
                          click: function($event) {
                            return _vm.getFlowDetail(
                              scope.row.complaintId,
                              scope.row.flowNum
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(scope.row.flowNum))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.flowStatusName))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "是否回访" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.isVisitName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "投诉来源" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.complaintsSourceName))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "投诉人",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.complainantsName))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "投诉人电话",
              "min-width": "130px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.complainantsPhone))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "投诉地址",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.complaintAddress))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "联系人",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.contact))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "联系人电话",
              "min-width": "130px",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.phone))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "问题发生地",
              "min-width": "110px",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.eventalSite))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "紧急情况" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.situationTypeName))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "预约处理时间",
              "min-width": "110px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.appointmentTime))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "投诉内容",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.complaintContent))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "处理结果",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.remark))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.actions"),
              "min-width": "280px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.status == "0" && scope.row.isVisit == "0"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-setting",
                              plain: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleDispatch(
                                  scope.row.complaintId,
                                  scope.row.flowNum
                                )
                              }
                            }
                          },
                          [_vm._v("派工")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "mini",
                          icon: "el-icon-search",
                          plain: ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleCheck(
                              scope.row.complaintId,
                              scope.row.flowNum
                            )
                          }
                        }
                      },
                      [_vm._v("查看")]
                    ),
                    scope.row.status == "2" && scope.row.isVisit == "1"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-news",
                              plain: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleReturnVisitDetail(
                                  scope.row.complaintId,
                                  scope.row.flowNum
                                )
                              }
                            }
                          },
                          [_vm._v("回访详情")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.listQuery.page,
              "page-sizes": [10, 20, 30, 50],
              "page-size": _vm.listQuery.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("complaint-detail", {
            attrs: {
              "key-value": _vm.complaintId,
              "flow-num": _vm.flowNum,
              "show-dialog": _vm.dialogFormVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormDispatchVisible,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormDispatchVisible = $event
            }
          }
        },
        [
          _c("complaint-dispatch", {
            attrs: {
              "key-value": _vm.complaintId,
              "show-dialog": _vm.dialogFormDispatchVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormTransferVisible,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormTransferVisible = $event
            }
          }
        },
        [
          _c("complaint-transfer", {
            attrs: {
              "key-value": _vm.complaintId,
              "show-dialog": _vm.dialogFormTransferVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormDisposeVisible,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormDisposeVisible = $event
            }
          }
        },
        [
          _c("complaint-dispose", {
            attrs: {
              "key-value": _vm.complaintId,
              "show-dialog": _vm.dialogFormDisposeVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormReturnVisible,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormReturnVisible = $event
            }
          }
        },
        [
          _c("complaint-returnVisit", {
            attrs: {
              "key-value": _vm.complaintId,
              "is-detail": true,
              "complainants-id": _vm.complaintId,
              "flow-num": _vm.flowNum,
              "show-dialog": _vm.dialogFormReturnVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }